import { Box, Button, Grid, Typography } from "@mui/material";
import styles from "../Candidate.module.css";
import { customTextColor } from "../../../utils/const";
import { useState } from "react";

const AddCandidateResume = () => {
  const [inputFields, setInputFields] = useState([{ value: '' }]);


  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index].value = event.target.value;
    setInputFields(values);
  };

  const handleAddInput = () => {

    setInputFields([...inputFields, { value: '' }]);
  };

  const handleRemoveInput = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };
  return (

    <Box>
      <Box className={styles.candidate_structure}>
        <Typography
          className={styles.add_candidate_heading}
          style={{ color: customTextColor }}
        >
          ADD CANDIDATE PROFILE
        </Typography>
        <Box className={styles.add_resume_header}>
          <Typography style={{ color: customTextColor }}>
            RESUME HEADER
          </Typography>
          <Box style={{ color: customTextColor }}>
            <span> Name : </span>
            <input type="text" />
          </Box>
          <Box style={{ color: customTextColor }}>
            <span> Skill Set : </span>
            <input type="text" />
          </Box>
          <Box style={{ color: customTextColor }}>
            <span> Mobile No : </span>
            <input type="number" />
          </Box>
          <Box style={{ color: customTextColor }}>
            <span>Email ID : </span>
            <input type="email" />
          </Box>
          <Box style={{ color: customTextColor }}>
            <span>LinkedIn Account URL : </span>
            <input type="text" />
          </Box>
        </Box>

        <Box className={styles.technical_skills}>
          <Typography style={{ color: customTextColor }}>
            Technical Skills
          </Typography>
          <textarea class="form-control" rows="5"></textarea>
        </Box>
        <Grid container>
          <Grid item xs={12} sm={12} md={3} lg={3} className={styles.custom_input_field}>
            {inputFields.map((inputField, index) => (
              <div key={index}>

                <input id="outlined-basic" placeholder="skill" variant="outlined"
                  type="text"
                  value={inputField.value}
                  onChange={(event) => handleChangeInput(index, event)}
                />
                {inputFields.length !== 1 && (

                  <b onClick={() => handleRemoveInput(index)}>-</b>

                )}
                {inputFields.length - 1 === index && (
                  <b onClick={handleAddInput}>+</b>
                )}
              </div>
            ))}
          </Grid>
        </Grid>



        <Box className={styles.add_resume_job_details}>

          <Box style={{ color: customTextColor }}>
            <span> Job Title : </span>
            <input type="text" />
          </Box>
          <Box style={{ color: customTextColor }}>
            <span> Client : </span>
            <input type="text" />
          </Box>
          <Box style={{ color: customTextColor }}>
            <span> Date : </span>
            <input type="date" />
          </Box>
          <span style={{ color: customTextColor }}>
            <span>About Client : </span>
            <textarea class="form-control" rows="3"></textarea>
          </span>
          <span style={{ color: customTextColor }}>
            <span>Job Responsibilities : </span>
            <textarea class="form-control" rows="3"></textarea>
          </span>
          <span style={{ color: customTextColor }}>
            <span>Environment : </span>
            <textarea class="form-control" rows="3"></textarea>
          </span>
        </Box>

        <Box className={styles.add_resume_btns}>
          <Button sx={{
            backgroundColor: '#2d73b5', '&:hover': {
              backgroundColor: '#2d73b5',
            },
          }}>BACK</Button>
          <Button sx={{
            backgroundColor: '#009945', '&:hover': {
              backgroundColor: '#009945',
            },
          }}>PUBLISH</Button>
        </Box>

      </Box>
    </Box>

  );
};

export default AddCandidateResume;
